import { ZOOM_LEVEL } from "Common/dictionaries/zoomLevel";
import { DETAILS_THRESHOLD_ZOOM_LEVEL, GRAPH_IN_PRESENTATION_MODE_CLASS_NAME, INTERMEDIATE_THRESHOLD_ZOOM_LEVEL } from "../constants";
import nodeTypeEnum from "./nodeType";
export default (context, nodeType) => {
    var _a;
    const presentationMode = Boolean((_a = context.canvasComponent) === null || _a === void 0 ? void 0 : _a.div.classList.contains(GRAPH_IN_PRESENTATION_MODE_CLASS_NAME));
    if (context.zoom < INTERMEDIATE_THRESHOLD_ZOOM_LEVEL)
        return ZOOM_LEVEL.LOW;
    if (context.zoom < DETAILS_THRESHOLD_ZOOM_LEVEL ||
        (presentationMode && nodeType === nodeTypeEnum.GROUP))
        return ZOOM_LEVEL.MEDIUM;
    return ZOOM_LEVEL.HIGH;
};
